import { useEffect } from 'react';

import { useIntlStore } from '@dcentralexpedientedigital/fe-shared/stores/intl-store';
import { getLocaleFromPathname } from '@dcentralexpedientedigital/fe-shared/utils/locale';

import { isValidLocale } from '../utils/language';

// This hook is used to sync the locale with the URL parameter, which has higher priority than the locale in the store
export const useSyncLocaleWithUrl = () => {
    const [locale, setLocale] = useIntlStore((state) => [state.locale, state.setLocale]);
    const localeParam = getLocaleFromPathname();

    useEffect(() => {
        if (localeParam && isValidLocale(localeParam) && localeParam !== locale) {
            setLocale(localeParam);
        }
    }, [localeParam, setLocale]);
};
